module.exports = function(bootstrap) {
	bootstrap.run(["Service", "services", function (Service, services) {
		new Service({
			name: 'getSaveShoeboxItem',
			group: "rbsmbl",
			url: "/rbsmbl/x-services/spendingAccount/receiptInbox/v1/shoeBoxItem/save",
			contentType: 'application/json',
			fetch: function(payload) {
				this.payload = payload;
				return this.post(this.payload);
			}
		});
	}]);
};